import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";

import Layout from "./components/layout";
import HomePage from "page/home";
import LoginPage from "page/login";
import JoinIntroPage from "page/join/intro";
import AuthLayout from "components/layout/authLayout";
import MyPageLayout from "components/view/mypage/layout";
import UserInfPage from "page/mypage/userInf";
import MyBookPage from "page/mypage/book/indx";
import MyBookLayout from "components/view/mypage/book/layout";
import BookPage from "page/book";
import LodListPage from "page/lod";
import BookLayout from "components/view/book/layout";
import Join from "components/view/join";
// import JoinEmailPage from "page/join/email";
import { useAuthContext } from "components/context/authContext";
import { useEffect } from "react";
import { alertControl } from "util/commAction";
import BookInfPage from "page/mypage/book/inf";
import ErrorPage from "components/layout/error";
import ResetPwdPage from "page/mypage/resetPwd";
import BookCancelInfPage from "page/mypage/cancel";
import TermPage from "page/join/email/term";
import EmailPage from "page/join/email/mail";
import PasswordPage from "page/join/email/pwd";
import InfoPage from "page/join/email/info";
import TermsPage from "page/term";
import { useTranslation } from "react-i18next";
import ServiceNotice from "components/layout/serviceNotice";
import "./App.css";
import { isServiceDown } from "util/constent";

// 업데이트 뷰
// import UpLayout from "renewal/component/layout";
// import UpLodListPage from "renewal/lod/index";
// import UpHome from "renewal/home";
// import UpdateBookLayout from "renewal/book/layout";
// import UpdateBookPage from "renewal/book/index";
// import UpAuthLayout from "renewal/auth/layout";
// import UpLogin from "renewal/auth/login";
// import UpMyPageLayout from "renewal/mypage/layout";
// import UpMyResvLayout from "renewal/mypage/resv/layout";
// import UpResvList from "renewal/mypage/resv";
// import UpResvDetail from "renewal/mypage/resv/detail";

//샘플 뷰
// import SampleBookStep1Page from "page/sample/book/step1";
// import SampleBookstep2Page from "page/sample/book/step2";
// import SampleMyBookPage from "page/sample/resv";
// import SampleResvInfPage from "page/sample/resv/detail";
// import SampleBookCancelInfPage from "page/sample/resv/cancel";
// import SampleBookStep3 from "components/view/sample/book/step3";
// import SampleBook from "page/sample/book";
// import Term from "components/view/join/email/term";

//결제, 로그인 뷰
// import Eximbay from "components/test/eximbay/payment";
// import GoogleLogin from "components/test/google";
// import AppleLogin from "components/test/apple";

// ✅ 점검 기간 설정

function App() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isLogin } = useAuthContext();

  useEffect(() => {
    if (
      !isLogin &&
      pathname.includes("mypage") &&
      !pathname.includes("resetpw")
    ) {
      alertControl({
        isOpen: true,
        inner: t("alr_mypage_chk_login"),
        click: () => {
          navigate("/login", {
            state: {
              prevPath: pathname,
            },
          });
        },
      });
    }
  }, [pathname, isLogin]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          {isServiceDown && (
            <>
              <Route path="" element={<ServiceNotice />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          )}
          {!isServiceDown && (
            <>
              <Route path="" element={<LodListPage />} />
              <Route path=":lodNo" element={<HomePage />} />
              <Route path=":lodNo/book" element={<BookLayout />}>
                <Route path="" element={<BookPage />} />
              </Route>
              <Route path="/" element={<AuthLayout />}>
                <Route path="login" element={<LoginPage />} />
                <Route path="join" element={<JoinIntroPage />} />
                <Route path="join" element={<Join />}>
                  <Route path="term" element={<TermPage />} />
                  <Route path="mail" element={<EmailPage />} />
                  <Route path="pwd" element={<PasswordPage />} />
                  <Route path="inf" element={<InfoPage />} />
                </Route>
              </Route>

              <Route path="mypage" element={<MyPageLayout />}>
                <Route path="" element={<UserInfPage />} />
                <Route path="resv" element={<MyBookLayout />}>
                  <Route path="" element={<MyBookPage />} />
                  <Route path=":rmPdNo" element={<BookInfPage />} />
                  <Route
                    path=":rmPdNo/cancel"
                    element={<BookCancelInfPage />}
                  />
                </Route>
              </Route>
              <Route path="mypage/meminfo" element={<MyPageLayout />}>
                <Route path="resetpw" element={<ResetPwdPage />} />
              </Route>
              <Route path="*" element={<ErrorPage />} />

              {/* 약관 */}
              <Route path="/term/:prvCd" element={<TermsPage />} />
            </>
          )}

          {/* 기존 샘플  뷰 */}
          {/* <Route path="sample/book" element={<BookLayout />}>
            <Route path="step1" element={<SampleBookStep1Page />} />
            <Route path="step2" element={<SampleBookstep2Page />} />
            <Route path="step3" element={<SampleBookStep3 />} />
          </Route>
          <Route path="sample" element={<MyPageLayout />}>
            <Route path="resv" element={<MyBookLayout />}>
              <Route path="wait" element={<SampleMyBookPage />} />
              <Route
                path="wait/:rmPdNo/detail"
                element={<SampleResvInfPage />}
              />
              <Route
                path=":rmPdNo/cancel"
                element={<SampleBookCancelInfPage />}
              />
            </Route>
          </Route> */}

          {/* EXIMBAY 결제창 연동 하기 */}
          {/* <Route path="/eximbay" element={<Eximbay />} /> */}
          {/* <Route path="/google" element={<GoogleLogin />} />
          <Route path="/apple" element={<AppleLogin />} /> */}
        </Route>

        {/* 샘플뷰 */}
        {/* <Route path="/sample" element={<Layout />}>
          <Route path="" element={<LodListPage />} />
          <Route path=":lodNo" element={<HomePage />} />

          <Route path=":lodNo/book" element={<BookLayout />}>
            <Route path="" element={<SampleBook />} />
          </Route>

          <Route path="mypage" element={<MyPageLayout />}>
            <Route path="" element={<UserInfPage />} />
            <Route path="resv" element={<MyBookLayout />}>
              <Route path="" element={<SampleMyBookPage />} />
              <Route path=":rmPdNo/detail" element={<SampleResvInfPage />} />
              <Route
                path=":rmPdNo/cancel"
                element={<SampleBookCancelInfPage />}
              />
            </Route>
          </Route>
        </Route> */}
      </Routes>
    </>
  );
}

export default App;
